import React from 'react';
import TableHeader from './TableHeader';
import DocumentRow from './DocumentRow';
import TableFooter from './TableFooter';

const ComparisonTable = ({
  tableId,
  lineItemZero,
  lineItemZeroObject,
  zones,
  index,
  totalLength,
  doc2Visibility,
  toggleDoc2Visibility,
  markForExport,
  theadStyle,
  tbodyStyle,
  trStyle,
  trStyleFlexStart,
  thStyle,
  tdPropStyle,
  tdValueStyle,
  verticalLabel,
  containsPropVal,
  validateRCV,
  validateACV,
  validateTotal,
  renderProperNote,
  renderAddNote,
  handleCheckboxChange,
  maxLength,
  data,
  comparisonID,
  returnDoc2Zones,
  lastRow,
  setDoc1Name,
  setDoc2Name,
  doc1Name,
  doc2Name,
  tableStyle
}) => {
  const itemKey = `${zones["Zone 1"]} vs. ${zones["Zone 2"]} ${lineItemZero}`;
  const showDoc2 = doc2Visibility[itemKey] || false;
  
  return (
    <table 
      style={tableStyle}
      id={itemKey}
      key={lineItemZero}
    >
      <TableHeader 
        zones={zones}
        index={index}
        totalLength={totalLength}
        itemKey={itemKey}
        doc2Visibility={doc2Visibility}
        toggleDoc2Visibility={toggleDoc2Visibility}
        theadStyle={theadStyle}
        returnDoc2Zones={returnDoc2Zones}
      />
      
      {/* First document row */}
      {Object.entries(lineItemZeroObject).slice(0, 1).map(([lineItem1, lineItem1PropsVals]) => (
        <tbody style={tbodyStyle} key={lineItem1}>
          {Object.entries(lineItem1PropsVals).slice(0, 1).map(([desc, descVal]) => {
            const totalEntry = Object.entries(lineItem1PropsVals).find(([key]) => key.toLowerCase() === 'total');
            return (
              <tr style={trStyle} key={desc}>
                <th
                  style={{
                    ...thStyle,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "90%"
                  }}
                >
                  <span title={`${desc}: ${descVal}`}>
                    {showDoc2
                      ? `${desc}: ${descVal}`
                      : `${desc.length > maxLength ? desc.slice(0, maxLength) + "..." : desc}` +
                        `: ${descVal.length > maxLength ? descVal.slice(0, maxLength) + "..." : descVal}`}
                  </span>
                  
                  {!showDoc2 && totalEntry && (
                    <span style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      fontWeight: "bold",
                      minWidth: "120px"
                    }}>
                      <span style={{ color: "#00B3B5" }}>Total:</span>
                      <span style={tdValueStyle}>{totalEntry[1]}</span>
                    </span>
                  )}
                </th>
              </tr>
            );
          })}
          
          {showDoc2 && (
            <DocumentRow 
              documentData={lineItem1PropsVals}
              isDoc1={true}
              data={data}
              comparisonID={comparisonID}
              setDocName={setDoc1Name}
              docName={doc1Name}
              trStyle={trStyle}
              verticalLabel={verticalLabel}
              containsPropVal={containsPropVal}
              tdPropStyle={tdPropStyle}
              tdValueStyle={tdValueStyle}
            />
          )}
        </tbody>
      ))}
      
      {/* Second document row */}
      {Object.entries(lineItemZeroObject).slice(1, 2).map(([lineItem2, lineItem2PropsVals]) => (
        <tbody style={tbodyStyle} key={lineItem2}>
          {Object.entries(lineItem2PropsVals).slice(0, 1).map(([desc, descVal]) => {
            const totalEntry = Object.entries(lineItem2PropsVals).find(([key]) => key.toLowerCase() === 'total');
            return (
              <tr style={trStyle} key={desc}>
                <th
                  style={{
                    ...thStyle,
                    display: "flex",
                    justifyContent: "space-between",
                    width: "90%"
                  }}
                >
                  <span title={`${desc}: ${descVal}`}>
                    {showDoc2
                      ? `${desc}: ${descVal}`
                      : `${desc.length > maxLength ? desc.slice(0, maxLength) + "..." : desc}` +
                        `: ${descVal.length > maxLength ? descVal.slice(0, maxLength) + "..." : descVal}`}
                  </span>
                  
                  {!showDoc2 && totalEntry && (
                    <span style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      fontWeight: "bold",
                      minWidth: "120px"
                    }}>
                      <span style={{ color: "#00B3B5" }}>Total:</span>
                      <span style={tdValueStyle}>{totalEntry[1]}</span>
                    </span>
                  )}
                </th>
              </tr>
            );
          })}
          
          {showDoc2 && (
            <DocumentRow 
              documentData={lineItem2PropsVals}
              isDoc1={false}
              data={data}
              comparisonID={comparisonID}
              setDocName={setDoc2Name}
              docName={doc2Name}
              trStyle={trStyle}
              verticalLabel={verticalLabel}
              containsPropVal={containsPropVal}
              tdPropStyle={tdPropStyle}
              tdValueStyle={tdValueStyle}
            />
          )}
        </tbody>
      ))}
      
      {/* Validation row */}
      <tbody style={tbodyStyle}>
        <tr style={trStyleFlexStart}>
          {Object.values(lineItemZeroObject).slice(3, 4).map((val, index) =>
            validateRCV(val)
          )}
          {Object.values(lineItemZeroObject).slice(4, 5).map((val, index) =>
            validateACV(val)
          )}
          {Object.entries(lineItemZeroObject).slice(5, 6).map(([key, val]) =>
            validateTotal(key, val)
          )}
        </tr>
      </tbody>
      
      {/* Notes */}
      <tbody>
        {renderProperNote(itemKey)}
      </tbody>
      
      {/* Footer with export checkbox */}
      <TableFooter 
        itemKey={itemKey}
        tbodyStyle={tbodyStyle}
        lastRow={lastRow}
        renderAddNote={renderAddNote}
        handleCheckboxChange={handleCheckboxChange}
        markForExport={markForExport}
      />
    </table>
  );
};

export default ComparisonTable;
